<template>
  <div v-if="!isMyTeam" class="team__header team__header_default">
    <div class="header__row">
      <div class="header__group">
        <div class="header__item header__logo">
          <a href="#" @click.prevent><img :src="logo" alt="Scount"></a>
        </div>
      </div>
      <div class="header__group">
        <div v-if="!isTeamStepRequired" class="header__item header__link">
          <Link variant="secondary" size="sm" @click="$emit('skip')">Пропустить</Link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Link from '@rr-component-library/link/src/main';

export default {
  name: 'TeamHeader',
  components: {
    Link,
  },
  props: {
    isMyTeam: {
      type: Boolean,
      default: false,
    },
    isTeamStepRequired: {
      type: Boolean,
      default: false,
    },
    showRegisterAdditionalStep: {
      type: Boolean,
      default: false,
    },
    logo: {
      type: String,
      default: '',
    },
  },
  emits: ['skip'],
};
</script>
